import React from "react"
import styles from "./rainbowbutton.module.scss"


interface Props {
  onClick: () => void
  href: string
  children: React.ReactNode,
  hidden?: boolean
  largeBottomMargin?: boolean
}

const RainbowButton = (props: Props) => {
  return (
    <div className={styles.rainbowButtonOutline} style={props.largeBottomMargin ? {marginBottom: '64px'} : {}} hidden={props.hidden}>
      <a className={styles.rainbowButton} onClick={props.onClick} href={props.href} target="_blank">{props.children}</a>
    </div>
  )
}

export default RainbowButton
